<template>
  <RCard class="addresses-tab q-pa-xl">
    <UpdateAddressModal v-model="modal" v-bind="$props" />

    <Grid gtc="1fr 1fr 1fr">
      <div className="main-address">
        <div className="text-body-3 text-secondary-2">Main address</div>

        <Grid gtc="auto 1fr" class="text-secondary-1 q-mt-md" align-items="center" gap="0 var(--r-space-md)">
          <InfoItem label="Address 1" :value="mainAddress.address_1" />
          <InfoItem label="Address 2" :value="mainAddress.address_2" />
          <InfoItem label="Postcode" :value="mainAddress.post_code" />
          <InfoItem label="City" :value="mainAddress.city" />
          <InfoItem label="State" :value="mainAddress.state" />
          <InfoItem label="Country/Region" :value="mainAddress.country" />
        </Grid>
      </div>
      <div className="bank-address">
        <div className="text-body-3 text-secondary-2">Bank address</div>

        <Grid gtc="auto 1fr" class="text-secondary-1 q-mt-md" align-items="center" gap="0 var(--r-space-md)">
          <InfoItem label="Address 1" :value="bankAddress.address_1" />
          <InfoItem label="Address 2" :value="bankAddress.address_2" />
          <InfoItem label="Postcode" :value="bankAddress.post_code" />
          <InfoItem label="City" :value="bankAddress.city" />
          <InfoItem label="State" :value="bankAddress.state" />
          <InfoItem label="Country/Region" :value="bankAddress.country" />
        </Grid>
      </div>
      <Grid justify-content="end" class="actions">
        <EditIcon class="cursor-pointer" with-hover @click.native="modal = true" />
      </Grid>
    </Grid>
  </RCard>
</template>

<script>
// Components
import EditIcon from '@/ui/icons/EditIcon'
import UpdateAddressModal from './components/UpdateAddressModal'
import InfoItem from './components/InfoItem'

export default {
  components: {
    EditIcon,
    UpdateAddressModal,
    InfoItem
  },

  props: {
    id: [Number, String], // from route
    mainAddress: {
      type: Object,
      required: true
    },
    bankAddress: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    modal: false
  })
}
</script>

<style lang="scss" scoped>
.addresses-tab {
  align-self: start;
}
</style>
